import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { global } from '../../../shared/global';

@Injectable({
    providedIn: 'root'
})
export class SchoolarshipRequestService {

    constructor(private http: HttpClient) { }

    // fillSection(data) {
    //     return this.http.post(global.baseAPIUrl + 'DropDown/fillSection', data, global.httpOptions);
    // }
    fillStandard(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillStandard', data, global.httpOptions);
    }
    fillAcademicYear(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillAcademicYear    ', data, global.httpOptions);
    }
    fillMedium(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
    }
    fillScholarshipType(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillScholarshipType', data, global.httpOptions);
    }
    getScholarshipRequestDetailList(data) {
        return this.http.post(global.baseAPIUrl + 'ScholarshipDetailRequest/getScholarshipRequestDetailList', data, global.httpOptions);
    }
    saveScholarshipDetailRequest(data) {
        return this.http.post(global.baseAPIUrl + 'ScholarshipDetailRequest/saveScholarshipDetailRequest', data, global.httpOptions);
    }
    getScholarshipDetailRequestByID(data) {
        return this.http.post(global.baseAPIUrl + 'ScholarshipDetailRequest/getScholarshipDetailRequestByID', data, global.httpOptions);
    }
    deleteScholarshipDetailRequest(data) {
        return this.http.post(global.baseAPIUrl + 'ScholarshipDetailRequest/deleteScholarshipDetailRequest', data, global.httpOptions);
    }
}